(function () {
  var root = document.querySelector('.t4s-au2');
  if (!root) return;
  var nodes = root.querySelectorAll('[data-au2-reveal]');
  if (!nodes.length) return;

  var reveal = function (el) { el.classList.add('is-revealed'); };

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        reveal(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });

  nodes.forEach(function (node) { observer.observe(node); });

  // Content must never stay hidden behind JS. If a section hasn't been
  // revealed within 1.5s (backgrounded tab, slow main thread), force it.
  setTimeout(function () {
    nodes.forEach(reveal);
    observer.disconnect();
  }, 1500);
})();
